import CoreBack from "../../../app/core/components/CoreBack/CoreBack";
import CoreInputField from "../../../app/core/components/CoreInputField/CoreInputField.jsx";
import { t } from "i18next";
import CoreSelectObjArr from "../../../app/core/components/CoreSelect/CoreSelectObjArr.jsx";
import {
  Button,
  Divider,
  // ImageList,
  // ImageListItem,
  // ImageListItemBar,
} from "@mui/material";
import { useGetAllPromptQuery } from "../../api/admin/aiPromptApi.js";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton.jsx";
import { useEffect, useState } from "react";
import BusinessCenterRoundedIcon from "@mui/icons-material/BusinessCenterRounded";
import LocalOfferRoundedIcon from "@mui/icons-material/LocalOfferRounded";
import HeadsetMicRoundedIcon from "@mui/icons-material/HeadsetMicRounded";
import BalanceRoundedIcon from "@mui/icons-material/BalanceRounded";
import BalconyRoundedIcon from "@mui/icons-material/BalconyRounded";
import ColorLensRoundedIcon from "@mui/icons-material/ColorLensRounded";
import CookieRoundedIcon from "@mui/icons-material/CookieRounded";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import DirectionsCarRoundedIcon from "@mui/icons-material/DirectionsCarRounded";
import {
  useCreateBotMutation,
  useDeleteBotMutation,
  useEditBotMutation,
  useGetAllBotQuery,
} from "../../api/admin/chatbotApi.js";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon.jsx";
import BorderClearRoundedIcon from "@mui/icons-material/BorderClearRounded";
import { toast } from "react-toastify";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog.jsx";
import CustomBotIcon from "../../../app/assets/custom-icons/CustomBotIcon.jsx";
import { useSelector } from "react-redux";

const SettingsChatBot = () => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const [icon, setIcon] = useState();
  const [listsBots, setListsBots] = useState();
  const [clear, setClear] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [formData, setFormData] = useState({
    aiPromptId: "",
    name: "",
    description: "",
    voiceToneType: "",
    iconUrl: icon,
  });

  const { data: getAllBot } = useGetAllBotQuery();
  const { data: promptList, isLoading: loadingPrompt } = useGetAllPromptQuery();

  const [createBot, { isLoading: loadingCreate }] = useCreateBotMutation();
  const [editBot, { isLoading: loadingEdit }] = useEditBotMutation();
  const [deleteBot, { isLoading: isDeleting }] = useDeleteBotMutation();

  const promptData = promptList?.Data?.value
    .filter((el) => el.type === "Agent")
    ?.map((prompt) => ({
      label: prompt.name,
      value: prompt.id,
    }));

  useEffect(() => {
    if (getAllBot && getAllBot.Data) {
      setListsBots(getAllBot.Data.value);
    }
  }, [getAllBot]);

  const typeOptions = [
    { label: t("Formale"), value: "f" },
    { label: t("Informale"), value: "i" },
    { label: t("Empatico"), value: "e" },
    { label: t("Tecnico"), value: "t" },
  ];

  const itemData = [
    { img: <LocalOfferRoundedIcon className="w-full h-full" />, name: "A" },
    { img: <BusinessCenterRoundedIcon className="w-full h-full" />, name: "B" },
    { img: <HeadsetMicRoundedIcon className="w-full h-full" />, name: "C" },
    { img: <BalanceRoundedIcon className="w-full h-full" />, name: "D" },
    { img: <BalconyRoundedIcon className="w-full h-full" />, name: "E" },
    { img: <ColorLensRoundedIcon className="w-full h-full" />, name: "F" },
    { img: <CookieRoundedIcon className="w-full h-full" />, name: "G" },
    { img: <DarkModeRoundedIcon className="w-full h-full" />, name: "H" },
    { img: <DirectionsCarRoundedIcon className="w-full h-full" />, name: "I" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    // setValidationErrors({ ...validationErrors, [name]: "" });
  };

  const handleCompilerForm = (el) => {
    setFormData({
      id: el.id,
      aiPromptId: el.aiPromptId,
      name: el.name,
      description: el.description,
      voiceToneType: el.voiceToneType,
      iconUrl: el.iconUrl,
    });
    setClear(true);
  };

  const handleEmptyForm = () => {
    setFormData({
      aiPromptId: "",
      name: "",
      description: "",
      voiceToneType: "",
      iconUrl: "",
    });
    setClear(false);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleDelete = () => {
    setOpenDeleteDialog(true);
  };

  const handleSave = () => {
    try {
      if (clear) {
        const bodyEdit = {
          id: formData.id,
          aiPromptId: formData.aiPromptId,
          name: formData.name,
          description: formData.description,
          voiceTone: "Formal",
          iconUrl: "",
        };
        editBot(bodyEdit)
          .unwrap()
          .then((res) => {
            if (res.Result !== 1) {
              toast.error(t("BotNotEdited"));
              return;
            } else {
              toast.success(t("BotEdited"));
            }
          });
      } else {
        const newBot = {
          aiPromptId: formData.aiPromptId,
          name: formData.name,
          description: formData.description,
          voiceTone: "Formal",
          iconUrl: "",
        };
        createBot(newBot)
          .unwrap()
          .then((res) => {
            if (res.Result !== 1) {
              toast.error(t("BotNotCreated"));
              return;
            }
            toast.success(t("BotCreated"));
            handleEmptyForm();
          });
      }
    } catch (err) {
      toast.error(t("ReqErr"));
      console.log(err);
    }
  };

  const confirmDelete = () => {
    deleteBot(formData.id)
      .then((res) => {
        if (res.data.Result === 1) {
          toast.success(t("BotDeleted"));
          setOpenDeleteDialog(false);
        } else {
          toast.error(t("BotNotDeleted"));
        }
      })
      .catch((err) => toast.error(err));
  };

  return (
    <div className="w-full">
      <div className="flex ">
        <CoreBack />
        <h2 className="fw-bold m-0">{t("Settings")}</h2>
      </div>

      <div className="w-full flex space-x-8 mt-10">
        <div
          className="w-3/12 flex flex-col h-[500px] overflow-auto p-4 rounded-lg"
          style={{ border: "solid 1px lightgrey" }}
        >
          <p className="px-2 font-bold">{t("SelectedAgentEdit")}</p>
          {listsBots?.map((el) => (
            <Button onClick={() => handleCompilerForm(el)}>
              <div className="w-full flex items-center space-x-4 border-solid border border-zinc-400 p-2 rounded-lg">
                {/* <img
                  alt={el.name}
                  src={"/img/placeholder-image.svg"}
                  style={{
                    width: "80px",
                    height: "auto",
                  }}
                /> */}

                <CustomBotIcon className="w-20 h-20" shadows={false} />

                <h3 style={{ color: `${colorPrimary}` }}>{el.name}</h3>
              </div>
              <Divider />
            </Button>
          ))}
        </div>

        <div className="w-4/12 h-full space-y-4">
          <div className="flex justify-between items-center">
            <h3 className="p-2 ">
              {formData.aiPromptId !== ""
                ? t("EditedAgent")
                : t("CreatedAgent")}
            </h3>
            <div className="">
              <CoreButtonHoverIcon
                disabled={!clear}
                onClick={handleEmptyForm}
                className={clear ? "text-violet-600  m-1" : "text-gray m-1"}
                icon={
                  <BorderClearRoundedIcon
                    className={clear ? "text-violet-600 " : "text-gray "}
                  />
                }
                testo={t("EmptyField")}
              />
            </div>
          </div>
          <CoreSelectObjArr
            className={""}
            name="aiPromptId"
            label="Seleziona Prompt"
            value={formData.aiPromptId}
            items={promptData || []}
            onChange={handleChange}
          />
          <CoreInputField
            className="w-full"
            label={t("Name")}
            name="name"
            onChange={handleChange}
            value={formData?.name}
          />
          <CoreInputField
            multiline
            rows={4}
            variant="outlined"
            className="w-full"
            label={t("Description")}
            name="description"
            onChange={handleChange}
            value={formData.description}
          />

          {/* <CoreSelectObjArr
            className={"mt-5 h-11"}
            name="voiceToneType"
            label={t("ToneOfVoice")}
            value={formData.voiceToneType}
            items={typeOptions}
            onChange={handleChange}
          /> */}

          <div className="flex justify-around py-8 items-end ">
            {clear && (
              <CoreButton
                onClick={handleDelete}
                testo={t("Delete")}
                className="btn-round bg-red-700 text-white border-red-700"
              />
            )}
            <CoreButton
              testo={t("Save")}
              className="bg-primary btn-round border-primary"
              onClick={handleSave}
              disabled={loadingCreate || loadingEdit}
            />
          </div>
        </div>
        {/* <div>
          <p className="font-bold mt-0">Seleziona un'icona per il tuo Agente</p>
          <ImageList sx={{ width: 450, height: 450 }} cols={3} rowHeight={145}>
            {itemData.map((item, i) => (
              <ImageListItem key={i}>
                <Button onClick={() => setIcon(item.name)}>{item.img}</Button>
                <ImageListItemBar position="bottom" title={item.name} />
              </ImageListItem>
            ))}
          </ImageList>
        </div> */}
      </div>

      <CoreDialog
        open={openDeleteDialog}
        title={t("Delete")}
        content={`${t("DeletingConfirm")} "${formData.name}"?`}
        positiveButton={t("Yes")}
        negativeButton={t("No")}
        handlePositive={confirmDelete}
        closeDialog={handleCloseDeleteDialog}
        disabledButton={isDeleting}
      />
    </div>
  );
};

export default SettingsChatBot;
